<script lang="ts">
import { h, Fragment, type PropType } from 'vue'
import type { Slice } from './types'
import { slices } from './slices'

export default defineComponent({
  props: {
    slice: {
      type: Object as PropType<Slice>,
      required: true,
    },
    noWrapperClass: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const sliceClass = computed(() => {
      return {
        'typography px-box-4': props.slice.type === 'Block' || props.slice.type === 'Image',
      }
    })

    const wrapperClass = computed(() => {
      // TODO review class props, noWrapperClass === boxed?
      if (props.noWrapperClass) {
        return ['']
      }
      return [
        props.slice.layout.includes('boxed') ? 'boxed' : 'free',
        { 'boxed-sidebar': props.slice.layout === 'boxed_33' },
      ]
    })

    return () => {
      const component = slices[props.slice.type]
      if (!component) {
        return h(Fragment)
      }
      return h(component, {
        content: props.slice.content,
        id: props.slice.id,
        'data-widget-type': props.slice.type,
        class: [props.slice.class, sliceClass.value, wrapperClass.value],
      })
    }
  },
})
</script>
